import React from "react";
import {observer} from "mobx-react";
import './modal.scss'
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";

const DeleteModeModal = observer(() => {
    const {modalStore, projectStore, generalStore} = useStores();

    function closeModal() {
        modalStore.resetModalData();
        modalStore.isDeleteModeDialogOpen = false;
    }

    async function deleteMode() {
        try {
            generalStore.isLoaderOpen = true;
            const {modeIndex} = modalStore.modalData;
            await projectStore.removeMode(modeIndex);
            await projectStore.refreshProjectDetails();
            closeModal();
        } catch (e) {
            console.error(e);
            modalStore.showErrorMessage(generalStore.translate('problemDeletingThisMode'));
        }
        generalStore.isLoaderOpen = false;
    }

    return (
        <GeneralDialog
            openControl='isDeleteModeDialogOpen'
            className='delete-dialog'
            onEnter={null}
            title={generalStore.translate('deleteMode')}
            body={
                <div className="dialog-description">
                    {generalStore.translate('deleteModeConfirmSentence')}
                </div>
            }
            isConfirmDisabled={false}
            onConfirm={deleteMode}
            confirmText={generalStore.translate('delete')}
        />
    );
});
export default DeleteModeModal;
